import { render, staticRenderFns } from "./TestLinkAccountAPIForm.vue?vue&type=template&id=5375e319"
import script from "./TestLinkAccountAPIForm.vue?vue&type=script&lang=js"
export * from "./TestLinkAccountAPIForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports